import { render } from "./Roles.vue?vue&type=template&id=09ab4881"
import script from "./Roles.vue?vue&type=script&lang=ts"
export * from "./Roles.vue?vue&type=script&lang=ts"
script.render = render

export default script